import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=3fb95f46"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=3fb95f46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports